import React from 'react';

export const WorkflowSection = ({ workflowSteps }) => {
  return (
    <section id="process" className="pt-4 pb-8 bg-white text-slate-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-8">
          <p className="text-[9px] font-bold tracking-[0.25em] text-amber-600 uppercase mb-1 font-sans">Workflow</p>
          <h2 className="text-2xl md:text-3xl font-serif font-medium text-slate-900 leading-none">Admin Workflow</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {workflowSteps.map(p => (
            <div key={p.step} className="border border-slate-200 rounded-xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group bg-slate-50">
              <div className="text-5xl font-serif font-light text-slate-200 group-hover:text-amber-600/30 transition-colors duration-300 mb-4">{p.step}</div>
              <h3 className="font-serif font-medium text-lg text-slate-900 mb-2">{p.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
